export const getDocumentData = (documents: any[] | undefined, docType: string) => {
  return documents?.find(
    (doc: any) => doc.docType?.toLowerCase() === docType?.toLowerCase()
  );
};

export const isFormFilled = (form: any, documents: any[] | undefined) => {
  const doc = documents?.find((d: any) => d.docType?.toLowerCase() === form.header.toLowerCase());
  if (!doc || !doc.data) return false;
  return form.fields.every((field: any) =>
    !field.required || (doc.data[field?.key] !== undefined && doc.data[field?.key] !== null && doc.data[field?.key] !== "")
  );
};

export const getExpiryDate = (form: any, documents: any[] | undefined) => {
  const doc = getDocumentData(documents, form.header);
  if (!doc || !doc.data) return null;

  const expiryField = form.fields.find((field: any) =>
    field?.key?.toLowerCase().includes('expiry') ||
    field?.key?.toLowerCase().includes('expirationdate') ||
    field.type?.toLowerCase() === 'date'
  );

  if (expiryField && doc.data[expiryField?.key]) {
    return new Date(doc.data[expiryField?.key]);
  }
  return null;
};

export const isExpired = (
  form: any,
  documents: any[] | undefined,
  currentDate = new Date()
) => {
  const expiryDate = getExpiryDate(form, documents);
  if (!expiryDate) return false;

  // Normalize current date (remove time)
  const today = new Date(currentDate);
  today.setHours(0, 0, 0, 0);

  if (form?.header?.toLowerCase() === "vehicle inspection") {
    const inspectionValidityPeriod = 365;

    const issueDate = new Date(expiryDate);
    issueDate.setHours(0, 0, 0, 0);

    const calculatedExpiryDate = new Date(issueDate);
    calculatedExpiryDate.setDate(
      issueDate.getDate() + inspectionValidityPeriod
    );

    return calculatedExpiryDate < today;
  }

  const normalizedExpiry = new Date(expiryDate);
  normalizedExpiry.setHours(0, 0, 0, 0);

  return normalizedExpiry < today;
};
export const isVerified = (form: any, documents: any[] | undefined) => {
  const doc = getDocumentData(documents, form.header);
  return (doc?.verifiedAdmin && doc?.verifiedAI) === true;
};

export const isFormFilledStrict = (form: any, documents: any[] | undefined) => {
  const doc = getDocumentData(documents, form.header);

  if (!doc || !doc.data) return false;
  // const requiredOk = (form.fields || []).every((f: any) => {
  //   if (!f?.required) return true;
  //   const v = doc.data[f?.key];
  //   return v !== undefined && v !== null && String(v).trim() !== "";
  // });
  const requiredOk = (form.fields || []).every((f: any) => {
    if (!f?.required) return true;
    const v = doc.data[f?.key];

    if (f.type === "Checkbox") {
      return v === true; // must be checked
    }

    return v !== undefined && v !== null && String(v).trim() !== "";
  });

  if (!requiredOk) return false;
  //   if (doc.rejectedReason) return false;
  return true;
};

export const getDocumentStatus = (form: any, documents: any[] | undefined, currentDate = new Date()) => {
  if (form.header === "Community Safety Education") {
    return null;
  }
  const doc = getDocumentData(documents, form.header);
  if (!doc || !doc.data) {
    return { status: "pending", text: "Please complete your documents verification" };
  }
  if (!isFormFilledStrict(form, documents)) {
    return { status: "pending", text: "Please complete your documents verification" };
  }
  const allKeysEmpty = Object.values(doc.data).every((v: any) => v === undefined || v === null || v === "");
  if (allKeysEmpty) {
    return { status: "pending", text: "Please complete your documents verification" };
  }
  if (isExpired(form, documents, currentDate)) {
    return { status: "expired", text: "Expired - Please update" };
  }
  if (doc.rejectedReason) {
    return { status: "rejected", text: "Rejected - Action Required" };
  }
  if (doc.verifiedAdmin && doc.verifiedAI) {

    return { status: "verified", text: "Verified ✓" };
  }
  return { status: "filled", text: "In Review" };
};

export const getDocumentDescription = (form: any, statusObj: any, doc: any, documents: any[] | undefined) => {
  const formHeader = form.header?.toLowerCase();
  if (doc?.rejectedReason) return doc.rejectedReason;
  if (!isFormFilledStrict(form, documents)) return "Please complete your documents verification";
  if (statusObj?.status === "expired") return "Please complete your documents verification";
  if (statusObj?.status === "pending" || statusObj?.status === "rejected") return "Please complete your documents verification";
  if (formHeader.includes("license") || formHeader.includes("licence")) return "Confirm your identity";
  if (formHeader.includes("vehicle registration")) return "Information about the vehicle";
  if (formHeader.includes("insurance")) return "To prevent delays, ensures your photo is clear and includes all four corners";
  if (formHeader.includes("inspection")) return "Get your vehicle inspected and upload the form";
  if (formHeader.includes("work") || formHeader.includes("eligibility")) return "Driver must provide valid proof of work eligibility in order to drive with RapidoRide. Select your documents type from the dropdown, then upload a photo";
  return form.description || "Confirm your identity";
};
